import { observer } from 'mobx-react';
import React from 'react';
import {
    CustomFieldsOptionsListDTO,
    DefaultPageType,
    ReplaysPageLayoutOptions,
    SessionPageLayoutOptions,
    UpcomingSessionsTypeOptions
} from '../../../../../../../../api/custom-pages.dao';
import { DefaultPageViewModel } from '../default-page.viewmodel';
import { IItemProps } from '../../../../../../../global/multi-selection-dropdown/multi-selection-dropdown';
import { AgendaPageFields } from './agenda-page.fields';
import { SessionsPageFields } from './sessions-page.fields';
import { SupportPageFields } from './support-page.fields';
import { ShowcasePageFields } from './showcase-page.fields';
import { WelcomePageFields } from './welcome-page.fields';
import { ReplaysPageFields } from './_replays-page/replays-page.fields';


export type Props = {
    pageVm: DefaultPageViewModel;
    sessionsLayoutOptions?: SessionPageLayoutOptions[];
    organizationTypes?: IItemProps[];
    customFieldsOptionsList?: CustomFieldsOptionsListDTO[];
    upcomingSessionsTypeOptions?: UpcomingSessionsTypeOptions[];
    replaysLayoutOptions?: ReplaysPageLayoutOptions[];
};
export const DefaultPageTypeFieldsMap = {
    [DefaultPageType.Agenda]: AgendaPageFields,
    [DefaultPageType.Session]: SessionsPageFields,
    [DefaultPageType.Support]: SupportPageFields,
    [DefaultPageType.Showcase]: ShowcasePageFields,
    [DefaultPageType.Speakers]: (): JSX.Element => null,
    [DefaultPageType.Welcome]: WelcomePageFields,
    [DefaultPageType.Replays]: ReplaysPageFields,
};

export const DefaultPageFields = observer((props: Props): JSX.Element => {
    const type = props.pageVm.getType();

    return type ? React.createElement(DefaultPageTypeFieldsMap[type], props) : null;
});
